import { createError, findFiscalYearsInPeriod, getCurrentFiscalYearMonthYearPeriod } from '@common/neo.tax';

import { ProductType } from '../graphql';
import { useAllFiscalYears, FiscalYear } from './useAllFiscalYears';
import { useCompany } from './useCompany';

export const useLastCompletedFiscalYear = ({ companyId }: { companyId: string }): FiscalYear | undefined => {
  const { company } = useCompany({ companyId });
  const { fiscalYears } = useAllFiscalYears({ companyId });

  if (!company || !fiscalYears) {
    return;
  }

  if (typeof company.businessQuestions.fiscalYearEndMonth !== 'number') {
    throw createError('MissingFiscalYearEndMonthError', 'Fiscal year end month is missing');
  }

  const currentFiscalYearPeriod = getCurrentFiscalYearMonthYearPeriod(company.businessQuestions.fiscalYearEndMonth);

  const enabledFiscalYears = fiscalYears.filter(
    (fiscalYear) => fiscalYear.enabledDatetime && fiscalYear.productType === ProductType.UsRd,
  );
  const currentYearFiscalYears = findFiscalYearsInPeriod(enabledFiscalYears, currentFiscalYearPeriod);
  if (currentYearFiscalYears.length > 1) {
    throw createError('MultipleFiscalYearsInPeriodError', 'Multiple fiscal years found in current tax year period');
  }

  return currentYearFiscalYears[0];
};
